import React, {useState, useEffect} from 'react'
import axios from '../../api/axios';
import { useImage } from '../../hooks/useImage';

const BookmarkStackoverflow = ({ bookmark, showColors = false }) => {

    const {tags, title} = bookmark.type_data
    // console.log({title, type_url, media})
    return (
        <>
            <div className={`w-full p-2`}>
                <div className='flex flex-row gap-2 items-center'>
                <svg xmlns="http://www.w3.org/2000/svg" className='w-20' viewBox="0 0 622 124">
                    <g fill="none" fill-rule="evenodd">
                        <path fill="#1E1B1D" fill-rule="nonzero" d="M142.7,76.742 L135.526,76.107 C129.895,75.654 127.716,73.383 127.716,69.568 C127.716,65.028 131.167,62.211 137.706,62.211 C142.338,62.211 146.424,63.302 149.606,65.754 L153.875,61.485 C149.875,58.216 144.156,56.673 137.8,56.673 C128.264,56.673 121.361,61.573 121.361,69.75 C121.361,77.106 125.994,81.011 134.712,81.738 L142.068,82.373 C147.244,82.828 149.515,85.007 149.515,88.912 C149.515,94.18 144.974,96.812 137.615,96.812 C132.074,96.812 127.261,95.359 123.715,91.635 L119.355,95.995 C124.26,100.717 130.163,102.443 137.701,102.443 C148.508,102.443 155.865,97.443 155.865,88.821 C155.865,80.463 150.506,77.468 142.695,76.74 L142.7,76.742 Z M198.613,56.671 C191.444,56.671 186.928,58.084 182.971,63.094 C182.917,63.163 187.261,67.386 187.261,67.386 C189.894,63.663 192.8,62.302 198.521,62.302 C206.695,62.302 209.965,65.571 209.965,72.109 L209.965,76.377 L196.527,76.377 C186.537,76.377 181.089,81.464 181.089,89.277 C180.984058,92.6262953 182.189462,95.884474 184.449,98.359 C187.265,101.266 190.897,102.446 197.072,102.446 C203.066,102.446 206.336,101.266 209.972,97.632 L209.972,101.9 L216.511,101.9 L216.511,71.565 C216.511,61.848 210.611,56.673 198.62,56.673 L198.613,56.671 Z M209.969,86.1 C209.969,89.825 209.242,92.368 207.698,93.82 C204.883,96.545 201.523,96.82 197.709,96.82 C190.625,96.82 187.445,94.367 187.445,89.19 C187.445,84.013 190.715,81.29 197.437,81.29 L209.969,81.29 L209.969,86.1 Z M242.118,62.489 C246.386,62.489 249.018,63.76 252.38,67.483 C252.38,67.483 256.758,63.228 256.722,63.19 C252.137,58.285 248.245,56.677 242.122,56.677 C230.86,56.677 222.322,64.305 222.322,79.562 C222.322,94.819 230.858,102.449 242.122,102.449 C248.297,102.449 252.202,100.813 256.834,95.819 L252.384,91.55 C249.024,95.274 246.39,96.636 242.122,96.636 C238.033212,96.7993765 234.138626,94.8861276 231.769,91.55 C229.68,88.644 228.863,85.193 228.863,79.562 C228.863,73.931 229.68,70.48 231.769,67.574 C234.138117,64.2373869 238.033165,62.3242873 242.122,62.489 L242.118,62.489 Z M298.122,57.155 L289.97,57.155 L269.71,76.875 L269.741,37.236 L263.2,37.236 L263.2,101.9 L269.74,101.9 L269.709,85.591 L277.64,77.632 L292.628,101.9 L300.71,101.9 L282.17,73.1 L298.122,57.155 Z M328.335,56.055 C321.635,56.055 317.108,58.666 314.322,61.625 C310.231,65.89 309.187,71.025 309.187,79.207 C309.187,87.475 310.231,92.607 314.322,96.876 C317.108,99.835 321.633,102.447 328.335,102.447 C335.037,102.447 339.651,99.835 342.435,96.876 C346.526,92.611 347.571,87.476 347.571,79.207 C347.571,71.026 346.526,65.89 342.435,61.625 C339.651,58.666 335.035,56.055 328.335,56.055 Z M333.645,90.261 C332.226419,91.6312106 330.305034,92.3548961 328.335,92.261 C326.391065,92.355011 324.496795,91.6295149 323.113,90.261 C320.762,87.911 320.502,83.908 320.502,79.207 C320.502,74.506 320.762,70.591 323.113,68.241 C324.49659,66.8721679 326.391005,66.1466163 328.335,66.241 C330.30511,66.1466229 332.226679,66.8703779 333.645,68.241 C335.994,70.591 336.256,74.507 336.256,79.207 C336.256,83.907 335.994,87.907 333.645,90.261 Z M377.7,56.575 L368.562,84.6 L359.336,56.573 L347.41,56.573 L364.123,101.92 L373,101.92 L389.623,56.573 L377.7,56.575 Z M408.873,56.053 C397.124,56.053 389.116,64.408 389.116,79.205 C389.116,97.571 399.387,102.445 410.092,102.445 C418.274,102.445 422.714,99.92 427.326,95.306 L420.451,88.606 C417.578,91.479 415.14,92.871 410.179,92.871 C403.825,92.871 400.257,88.606 400.257,82.771 L428.631,82.771 L428.631,77.726 C428.631,65.279 421.494,56.053 408.873,56.053 Z M400.257,75.027 C400.273614,73.3485451 400.629053,71.6907352 401.302,70.153 C402.728026,67.2748247 405.662422,65.4538855 408.8745,65.4538855 C412.086578,65.4538855 415.020974,67.2748247 416.447,70.153 C417.117747,71.6914042 417.472764,73.3488292 417.491,75.027 L400.257,75.027 Z M445.322,60.927 L445.322,56.575 L434.267,56.575 L434.267,101.922 L445.582,101.922 L445.582,74.593 C445.582,68.848 449.412,66.236 452.894,66.236 C455.1886,66.1567159 457.391459,67.1404382 458.864,68.902 L467.43,60.318 C464.296,57.184 461.163,56.053 456.724,56.053 C452.407599,56.0018792 448.269295,57.7711856 445.324,60.927 L445.322,60.927 Z M470.941,51.848 L470.941,101.876 L482.255,101.876 L482.255,66.122 L490.611,66.122 L490.611,57.506 L482.255,57.506 L482.255,52.545 C482.255,49.934 483.562,48.454 486.255,48.454 L490.607,48.454 L490.607,38.881 L484.167,38.881 C474.939,38.881 470.937,45.408 470.937,51.848 L470.941,51.848 Z M537.191,56.048 C530.491,56.048 525.963,58.659 523.178,61.618 C519.088,65.883 518.043,71.018 518.043,79.2 C518.043,87.468 519.088,92.6 523.178,96.869 C525.963,99.828 530.489,102.44 537.191,102.44 C543.893,102.44 548.507,99.828 551.291,96.869 C555.381,92.604 556.426,87.469 556.426,79.2 C556.426,71.019 555.381,65.883 551.291,61.618 C548.506,58.659 543.891,56.048 537.191,56.048 Z M542.501,90.254 C541.082419,91.6242106 539.161034,92.3478961 537.191,92.254 C535.247065,92.348011 533.352795,91.6225149 531.969,90.254 C529.619,87.904 529.358,83.901 529.358,79.2 C529.358,74.499 529.619,70.584 531.969,68.234 C533.35259,66.8651679 535.247005,66.1396163 537.191,66.234 C539.16111,66.1396229 541.082679,66.8633779 542.501,68.234 C544.85,70.584 545.112,74.5 545.112,79.2 C545.112,83.9 544.85,87.9 542.501,90.254 Z M609.883,56.57 L602.573,84.6 L593.26,56.575 L584.993,56.575 L575.765,84.6 L568.455,56.573 L556.444,56.573 L570.37,101.92 L579.683,101.92 L589.17,73.46 L598.657,101.92 L607.97,101.92 L621.809,56.573 L609.883,56.57 Z M507.3,88.257 L507.3,38.881 L495.989,38.881 L495.989,88.953 C495.989,95.394 499.907,101.922 509.219,101.922 L515.659,101.922 L515.659,92.347 L511.308,92.347 C508.436,92.347 507.308,90.955 507.308,88.257 L507.3,88.257 Z M174,64.246 L180.046,58.2 L167.666,58.2 L167.666,43.5 L161.127,43.5 L161.127,89.912 C161.127,96.541 164.941,101.9 172.57,101.9 L177.2,101.9 L177.2,96.269 L173.75,96.269 C169.573,96.269 167.666,93.816 167.666,89.73 L167.666,64.246 L174,64.246 Z"/>
                        <polygon fill="#BBBBBB" points="88 80 99 80 99 124 0 124 0 80 11 80 11 113 88 113"/>
                        <path fill="#F58025" fill-rule="nonzero" d="M22.9878906,76.73 L77.0128906,88.085 L79.2838906,77.285 L25.2588906,65.925 L22.9878906,76.73 Z M30.1368906,50.861 L80.1828906,74.169 L84.8448906,64.16 L34.7978906,40.852 L30.1368906,50.861 Z M43.9848906,26.308 L86.4128906,61.639 L93.4788906,53.154 L51.0508906,17.824 L43.9848906,26.308 Z M71.3718906,0.192 L62.5118906,6.782 L95.4598906,51.082 L104.319891,44.493 L71.3718906,0.192 Z M22,102 L77,102 L77,91 L22,91 L22,102 Z"/>
                    </g>
                </svg>
                </div>
                <div className='text-lg font-bold py-1 flex'>{title}</div>
                <div className='text-xs whitespace-pre-line flex gap-2 justify-center'>
                    {tags && tags.map((tag) => 
                        <div className={'rounded-full bg-green-300 px-2 py-1'}>{tag}</div>
                    )}
                </div>
            </div>

           
        
        </>
    )
}
const BookmarkReddit = ({ bookmark, showColors = false }) => {

    const {post_type, externalLink, title, selftext, subreddit, selftext_html, type_url, media, is_video, url_overridden_by_dest, permalink, is_gallery, mediaArray} = bookmark.type_data
    // console.log({title, type_url, media})
    return (
        <>
            <div className={`${selftext && 'fade'} w-full overflow-hidden`}>
                <div className='flex flex-row gap-2 items-center'>
                    <svg viewBox="0 0 20 20" className='w-6'><g><circle fill="#FF4500" cx="10" cy="10" r="10"></circle><path fill="#FFF" d="M16.67,10A1.46,1.46,0,0,0,14.2,9a7.12,7.12,0,0,0-3.85-1.23L11,4.65,13.14,5.1a1,1,0,1,0,.13-0.61L10.82,4a0.31,0.31,0,0,0-.37.24L9.71,7.71a7.14,7.14,0,0,0-3.9,1.23A1.46,1.46,0,1,0,4.2,11.33a2.87,2.87,0,0,0,0,.44c0,2.24,2.61,4.06,5.83,4.06s5.83-1.82,5.83-4.06a2.87,2.87,0,0,0,0-.44A1.46,1.46,0,0,0,16.67,10Zm-10,1a1,1,0,1,1,1,1A1,1,0,0,1,6.67,11Zm5.81,2.75a3.84,3.84,0,0,1-2.47.77,3.84,3.84,0,0,1-2.47-.77,0.27,0.27,0,0,1,.38-0.38A3.27,3.27,0,0,0,10,14a3.28,3.28,0,0,0,2.09-.61A0.27,0.27,0,1,1,12.48,13.79Zm-0.18-1.71a1,1,0,1,1,1-1A1,1,0,0,1,12.29,12.08Z"></path></g></svg>
                    <p className='text-sm'>r/{subreddit}</p>
                </div>
                <div className='text-lg font-bold py-1'>{title}</div>
                <div className='text-xs whitespace-pre-line overflow-hidden'>
                    {selftext && selftext}
                    {post_type === 'image' && <img className='rounded-lg' src={bookmark.type_data.imageLink} alt="external" />}
                    {post_type === 'galleryImage' && <img className='rounded-lg' src={mediaArray[0]} alt="huh" />}
                    {/* {post_type === 'external' && <div className='text-xs'>{externalLink}</div>} */}
                </div>
            </div>

           
        
        </>
    )
}

const BookmarkHackernews = ({ bookmark, showColors = false }) => {

    const {by, text, type, title, url} = bookmark.type_data
    // console.log({title, type_url, media})
    return (
        <>
            
                <div className={`'max-h-[45rem] overflow-hidden bg-white p-4 rounded-lg
                            ${showColors && 'bg-gradient-to-b from-[#f6f6ee] via-white to-white'}'`}>
                    <div className={`${text && 'fade'} h-full`}>
                        <div className='flex flex-row gap-2 items-center'>
                            <img src="https://news.ycombinator.com/y18.gif" alt="logo" />
                            {/* <p className='text-sm'>{by}</p> */}
                        </div>
                        <div className='text-lg font-bold py-1'>{title}</div>
                        <div className='text-xs whitespace-pre-line'>
                            
                            {text && text}
                            
                        </div>
                    </div>
                </div>    
                
        
        </>
    )
}

const BookmarkTiktokVideo = ({ bookmark }) => {

    const {type, title, author_url, author_name, html, thumbnail_url, provider_name} = bookmark.type_data

    const bigThumb = true
    
    if (bigThumb) {
        return (
            <>
            <div className='relative damn overflow-hidden rounded-lg
                            '>
                <img src={thumbnail_url} alt='shit' className='damn rounded-lg overflow-hidden' />
                
            </div>
        
                
        </>
        )
    }



    return (
        <>
            <div className='relative damn w-full h-[20rem] overflow-hidden flex justify-center items-center bg-white p-4 rounded-lg
                            bg-gradient-to-b from-[#FFD7DF] via-white to-white'>
                <img src={thumbnail_url} alt='shit' className='damn rounded-lg overflow-hidden object-contain h-full' />
            </div>
        
                
        </>
    )
}

const BookmarkImage = ({ bookmark }) => {

    const {fileKey, originalName} = bookmark.type_data;

    const {isLoading, isError, error, data, isFetching} = useImage(fileKey)


    return (
        <>
            <img src={data} alt='fuck' className='rounded-lg' />
            
        </>
    )
    
}

const BookmarkVideo = ({ bookmark }) => {

    const {title, description, image, price, currency} = bookmark.type_data;

    return (
        <>
                <img src={image} alt='fuck' className='rounded-lg w-full' />
                <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center'>
                    <svg aria-hidden="true" className='w-20 h-20 fill-white'>
                        <path d="m37.5 0c-20.751 0-37.5 16.749-37.5 37.5s16.749 37.5 37.5 37.5 37.5-16.749 37.5-37.5-16.749-37.5-37.5-37.5zm12.999 39.501-18.75 11.6663c-.416.249-.832.3339-1.251.3339-.416 0-.75-.082-1.166-.3339-.75-.4161-1.166-1.1661-1.166-2.083v-23.3348c0-.832.5009-1.667 1.166-2.083.75-.416 1.667-.416 2.417.0821l18.75 11.751c.668.416 1.084 1.166 1.084 2.001 0 .832-.416 1.582-1.084 2.001z"/>
                    </svg>
                </div>
               
        </>
    )
}

const BookmarkPending = ({ pendingBookmark }) => {

    return (
        <>
            <div className='w-full h-40 bg-white flex justify-center items-center flex-col'>
                <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-white fill-[#ff5923]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
                <div className='text-sm mt-4'>Taking Screenshot...</div>
            </div>
        </>
    )
}

const BookmarkProduct = ({ bookmark }) => {

    const {title, description, image, price, currency} = bookmark.type_data;


    return (
        <>
                <img src={image} alt='fuck' className='' />
                
        </>
    )
}

const BookmarkArticle = ({ bookmark }) => {

    
    const {isLoading, isError, error, data, isFetching} = useImage(bookmark.type_data.thumbnail_key)


    let {title, description, image, author, published, thumbnail_key} = bookmark.type_data
    // console.log({title, description, image, author, published, thumbnail_key})
    // console.log({thumbnail_key})

    const [state, setState] = useState(image)
    const [isThumbnail, setIsThumbnail] = useState(thumbnail_key)

    const shit = null

    useEffect(() => {
        async function images(bookmark) {

            const response = await axios
            .get(`/bookmarks/${bookmark.bookmark_id}/thumbnail`)
            
            // console.log(response.data)

            return response.data

            
        }    
        // console.log(state)
        if (isThumbnail) {
            images(bookmark).then(res => {
                setState(res)
                console.log(res)
            })

        }
        
    }, [shit])


    return (
        <>
            
                <img src={state} alt='fuck' className='rounded-lg w-full' />
            

        </>
    )
}

const BookmarkWebsite = ({ bookmark }) => {

    const {isLoading, isError, error, data, isFetching} = useImage(bookmark.type_data.thumbnail_key)

    const typeData = bookmark.type_data


    const imageURL = data
    // console.log(imageURL)

    if (isLoading) return

    // const image = new Image();
    // image.onload = function() {
    //     alert(this.width + ' ' + this.height)
    // }

    // image.src=imageURL
    if (imageURL) {
        return (
            <>
                {bookmark.type === 'website' &&
                    <div className=''>
                        <img src={imageURL} draggable='true' alt='fuck' className='damn rounded-lg overflow-hidden object-cover w-fulle' />
                    </div>
                }
    
            </>
        )
        
    }
}

const BookmarkTwitter = ({ bookmark, showColors = false }) => {

    const typeData = bookmark.type_data

    const { media } = typeData
    // console.log(typeData)


    return (
        <div className=''>
            <div className='flex flex-row text-sm gap-2 items-center mb-2'>
                <svg className='w-5 fill-[#23a2f0]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/>
                </svg>
                <div className='text-sm text-gray-400'>
                    @{typeData.authorName}
                </div>
            </div>
            <span className='text-xs leading-2 whitespace-pre-wrap'>{typeData.tweetText}</span>
            <div className='flex w-full flex-row gap-1 rounded mt-4'>
                {media && media.map((media, index) => {
                    return media.type === 'photo' && <img key={index} src={media.url} alt="" className='w-full rounded'/>
                })}
            </div>
        </div>
    )
}

export { BookmarkStackoverflow, BookmarkHackernews, BookmarkArticle, BookmarkImage, BookmarkPending, BookmarkProduct, BookmarkReddit, BookmarkTiktokVideo, BookmarkTwitter, BookmarkVideo, BookmarkWebsite } 